import { render, staticRenderFns } from "./LandingSidebar.vue?vue&type=template&id=27659e42&scoped=true&"
import script from "./LandingSidebar.vue?vue&type=script&lang=js&"
export * from "./LandingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LandingSidebar.vue?vue&type=style&index=0&id=27659e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27659e42",
  null
  
)

export default component.exports